// Angular
import { Component } from '@angular/core';
import { SharedService } from '../../../../shared/sharedServices/shared.service';
import { HecResponse } from '../../../../shared/shared-interfaces/hecResponse';
import { HEC_CONSTANTS } from '../../../../utilities/constants';

@Component({
	selector: 'kt-topbar',
	templateUrl: './topbar.component.html',
	styleUrls: ['./topbar.component.scss'],
})
export class TopbarComponent { 
	public notificationList:any;
	constructor(private sharedService:SharedService){
		// this.getNotificationsList();
	}

	public getNotificationsList(page):void {
		let data= 
			{"data":["DAS","DES"]}
		this.sharedService.getAllNotificationsByAcronyms(page,data).subscribe(
			(res:HecResponse)=>{
				if(res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK){
					this.notificationList = res.data;
				}
			}
		)
	}

}
